import Inputmask from 'inputmask';
import Pikaday from 'pikaday';

import { Controller } from 'stimulus';
import './date.scss'

export default class extends Controller {
  initialize() {
    this.pikaday = new Pikaday({
      field: this.element,
      format: 'DD.MM.YYYY',
      i18n: {
        previousMonth : 'Предыдущий месяц',
        nextMonth     : 'Следующий месяц',
        months        : ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
        weekdays      : ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
        weekdaysShort : ['Вс','Пн','Вт','Ср','Чт','Пт','Сб']
      },
      firstDay: 1,
      toString(date) {
        let day = date.getDate();
        if (day <= 9) {
          day = `0${day}`;
        }

        let month = date.getMonth() + 1;
        if (month <= 9) {
          month = `0${month}`;
        }

        return `${day}.${month}.${date.getFullYear()}`;
      }
    });

    this.inputmask = Inputmask({
      mask: { 'mask': '##.@#.####'},
      greedy: true,
      definitions: { '#': { validator: '[0-9]', cardinality: 1 }, '@': { validator: '[0-1]', cardinality: 1 } }
    }).mask(this.element)
  }
}
